module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-1"
  }, [_c('h2', [_c('trans', {
    attrs: {
      "msg": "step1_title"
    }
  })], 1), _vm._v(" "), _c('p', [_c('trans', {
    attrs: {
      "msg": "step1_description"
    }
  })], 1), _vm._v(" "), _c('input', {
    ref: "field",
    class: _vm.invalid.indexOf('name') !== -1 && 'error' || null,
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "click": _vm.change_value,
      "keyup": _vm.change_value
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b9a9f078"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Step1.vue
// module id = 76
// module chunks = 0